const space = process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID
const accessToken = process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_KEY

export const fetchContentfulData = async (
  contentType: string,
  options?: {
    include?: number
  },
) => {
  const url = new URL(`https://cdn.contentful.com/spaces/${space}/environments/master/entries`)
  url.searchParams.set('access_token', accessToken ?? '')
  url.searchParams.set('content_type', contentType)
  if (typeof options?.include === 'number') {
    url.searchParams.set('include', String(options.include))
  }

  const response = await fetch(
    url.toString(),
    // 테스트를 위한 캐시 무효화
    { cache: 'no-store' }
  )
  if (!response.ok) {
    throw new Error('Failed to fetch items')
  }
  const data = await response.json()
  return data
}

export const fetchContentfulFaqData = async (contentType: string, category: string) => {
  const response = await fetch(
    `https://cdn.contentful.com/spaces/${space}/environments/master/entries?access_token=${accessToken}&content_type=${contentType}&fields.category[in]=${category}`,
    { cache: 'no-store' }
  )

  if (!response.ok) {
    throw new Error('Failed to fetch items')
  }

  const data = await response.json()
  return data
}

export const fetchContentfulFaqDetail = async (id: string) => {
  const response = await fetch(`https://cdn.contentful.com/spaces/${space}/environments/master/entries?access_token=${accessToken}&sys.id=${id}&include=2`,
    { cache: 'no-store' }
  )

  if (!response.ok) {
    throw new Error('Failed to fetch item')
  }

  const data = await response.json()
  return data
}

export const fetchContentfulTermsData = async (contentType: string, category: string) => {
  const response = await fetch(
    `https://cdn.contentful.com/spaces/${space}/environments/master/entries?access_token=${accessToken}&content_type=${contentType}&fields.category[in]=${category}&include=3`,
    { cache: 'no-store' }
  )

  if (!response.ok) {
    throw new Error('Failed to fetch items')
  }

  const data = await response.json()
  return data
}

export const fetchContentfulNoticeDetail = async (id: string, options?: { include?: number }) => {
  const url = new URL(`https://cdn.contentful.com/spaces/${space}/environments/master/entries`)
  url.searchParams.set('access_token', accessToken ?? '')
  url.searchParams.set('sys.id', id)
  if (typeof options?.include === 'number') {
    url.searchParams.set('include', String(options.include))
  }

  const response = await fetch(url.toString(), { cache: 'no-store' })
  if (!response.ok) {
    throw new Error('Failed to fetch notice detail')
  }
  const data = await response.json()
  return data
}